import { Button } from "@mui/material";

import { className } from "utils/strings";

import ICON from "components/icons/plusThink.svg";

export const UploadButton = (props: {
  active: boolean;
  onClick: () => void;
}): JSX.Element => {
  return (
    <Button onClick={props.onClick} className={className({
      "upload": true,
      "active": props.active,
      "inactive": !props.active,
    })}>
      <div className="plus">
        <img src={ICON} alt="" />
      </div>
      <label>Upload</label>
    </Button>
  );
};
